import { useTranslation } from 'react-i18next'
import { common } from '@ocean/ui'
import { List, NotificationsListItem } from 'components/lists'
import { ListItemCommonProps } from 'components/lists/types'
import { namespace } from 'modules/Notifications/localization'
import { EmptyWrapper } from './NotificationsList.styled'

const { Note } = common

const I18_PATH = `${namespace}:notifications`

const NOTIFICATION_ITEMS: ListItemCommonProps[] = [
  {
    title: 'Your deadline for “Demonstrating power over steering…” is approaching.',
    footer: '5 hours ago',
  },
  {
    title: 'Report: “Progress Q1 2020” has been added to your account.',
    footer: '3 hours ago',
  },
  {
    title: 'Your deadline for “Demonstrating power over steering…” is approaching.',
    footer: '6 hours ago',
  },
  {
    title: 'Report: “Progress Q1 2020” has been added to your account.',
    footer: '1 hours ago',
  },
  {
    title: 'Your deadline for “Demonstrating power over steering…” is approaching.',
    footer: '5 hours ago',
  },
]

// TODO: Fix with real API data
type NotificationsListProps = {
  items?: ListItemCommonProps[]
}

const NotificationsList: React.FC<NotificationsListProps> = () => {
  const { t } = useTranslation()

  // TODO: Handle empty result
  if (false) {
    return (
      <EmptyWrapper>
        <Note description={t(`${I18_PATH}.emptyResult`)} />
      </EmptyWrapper>
    )
  }

  return (
    <List>
      {NOTIFICATION_ITEMS.map((item, index) => (
        <NotificationsListItem {...item} key={index} />
      ))}
    </List>
  )
}

export default NotificationsList
